import React from 'react';
import { propOr } from 'ramda';
import { DashedTitle, Icon } from '@fasstech/middle-design-system';
import {
  ControlledInput,
  ControlledSelect
} from '@@viewCommonComponents/controlled/index.js';
import {
  isRequiredInput,
  isRequiredSelect
} from '@@viewHelpers/validations/index.js';

const REMOVE_ZONE_LABEL = 'Supprimer la zone';

const DemographyBlock = ({
  index,
  form,
  getMiddleText,
  getMiddleBoolean,
  getMiddleNumber,
  regimeObligatoire,
  coverageZoneFlags,
  zoneOptions,
  isRemovable,
  onRemove,
  employeeCountTooltipText,
  spouseCountTooltipText,
  childrenCountTooltipText,
  employeeAverageAgeTooltipText
}) => {
  const field = (name) => `demographies.${index}.${name}`;

  return (
    <div className={'p-4'}>
      {coverageZoneFlags.isDisplayed && (
        <div className={'flex items-center justify-between gap-4 mb-4'}>
          <DashedTitle>{coverageZoneFlags.label}</DashedTitle>
          {isRemovable && (
            <button
              type="button"
              className={
                'flex items-center cursor-pointer p-2 rounded-full transition-colors hover:bg-gray-100'
              }
              onClick={onRemove}
              aria-label={REMOVE_ZONE_LABEL}
              title={REMOVE_ZONE_LABEL}
              data-testid={`removeCoverageZone-${index}`}
            >
              <Icon name="delete" size={20} />
            </button>
          )}
        </div>
      )}
      <ControlledSelect
        name={field('salesArea.label')}
        label={coverageZoneFlags.label}
        form={form}
        options={zoneOptions}
        isSearchable
        rules={isRequiredSelect(zoneOptions, coverageZoneFlags.isRequired)}
        data-testid={`ENTREPRISE_ZONE_COUVERTURE-${index}`}
        isDisplayed={coverageZoneFlags.isDisplayed}
        containerClassName={'mb-4'}
      />
      <div className="grid grid-cols-2 gap-8">
        <ControlledInput
          name={field('employeeCount')}
          label={getMiddleText('ENTREPRISE_DEMOGRAPHIE_NB_SALARIES_LABEL')}
          number={true}
          form={form}
          data-testid={`employeeCount-${index}`}
          rules={isRequiredInput(
            getMiddleBoolean(
              'ENTREPRISE_DEMOGRAPHIE_NB_SALARIES_EST_OBLIGATOIRE'
            )
          )}
          isDisplayed={getMiddleBoolean(
            'ENTREPRISE_DEMOGRAPHIE_NB_SALARIES_EST_NECESSAIRE'
          )}
          min={getMiddleNumber('ENTREPRISE_DEMOGRAPHIE_NB_SALARIES_MIN')}
          max={getMiddleNumber('ENTREPRISE_DEMOGRAPHIE_NB_SALARIES_MAX')}
          tootip={employeeCountTooltipText}
        />
        <ControlledInput
          name={field('employeeAverageAge')}
          label={getMiddleText(
            'ENTREPRISE_DEMOGRAPHIE_AGE_MOYEN_SALARIE_LABEL'
          )}
          number={true}
          form={form}
          data-testid={`employeeAverageAge-${index}`}
          rules={isRequiredInput(true)}
          isDisplayed={getMiddleBoolean(
            'ENTREPRISE_DEMOGRAPHIE_AGE_MOYEN_SALARIE_EST_NECESSAIRE'
          )}
          min={getMiddleNumber('ENTREPRISE_DEMOGRAPHIE_AGE_MOYEN_SALARIE_MIN')}
          max={getMiddleNumber('ENTREPRISE_DEMOGRAPHIE_AGE_MOYEN_SALARIE_MAX')}
          tootip={employeeAverageAgeTooltipText}
        />
        <ControlledInput
          name={field('partnerCount')}
          label={getMiddleText('ENTREPRISE_DEMOGRAPHIE_NB_CONJOINTS_LABEL')}
          number={true}
          form={form}
          data-testid={`employeeSpouseCount-${index}`}
          isDisplayed={getMiddleBoolean(
            'ENTREPRISE_DEMOGRAPHIE_NB_CONJOINTS_EST_NECESSAIRE'
          )}
          min={getMiddleNumber('ENTREPRISE_DEMOGRAPHIE_NB_CONJOINTS_MIN')}
          max={getMiddleNumber('ENTREPRISE_DEMOGRAPHIE_NB_CONJOINTS_MAX')}
          tootip={spouseCountTooltipText}
        />
        <ControlledInput
          name={field('childrenCount')}
          label={getMiddleText('ENTREPRISE_DEMOGRAPHIE_NB_ENFANTS_LABEL')}
          number={true}
          form={form}
          data-testid={`employeeChildCount-${index}`}
          isDisplayed={getMiddleBoolean(
            'ENTREPRISE_DEMOGRAPHIE_NB_ENFANTS_EST_NECESSAIRE'
          )}
          min={getMiddleNumber('ENTREPRISE_DEMOGRAPHIE_NB_ENFANTS_MIN')}
          max={getMiddleNumber('ENTREPRISE_DEMOGRAPHIE_NB_ENFANTS_MAX')}
          tootip={childrenCountTooltipText}
        />
        <ControlledSelect
          name={field('socialSecurities.0.regime')}
          label={getMiddleText('ENTREPRISE_DEMOGRAPHIE_REGIME_LABEL')}
          form={form}
          options={propOr([], 'regimes', regimeObligatoire)}
          data-testid={`socialSecuritiesRegime-${index}`}
          rules={isRequiredSelect(
            propOr([], 'regimes', regimeObligatoire),
            true
          )}
          isDisplayed={getMiddleBoolean(
            'ENTREPRISE_DEMOGRAPHIE_REGIME_EST_NECESSAIRE'
          )}
        />
      </div>
    </div>
  );
};

export default DemographyBlock;
